import { render, staticRenderFns } from "./SaveAsGoogleDriveSection.vue?vue&type=template&id=3d15cc9e&scoped=true"
import script from "./SaveAsGoogleDriveSection.vue?vue&type=script&lang=js"
export * from "./SaveAsGoogleDriveSection.vue?vue&type=script&lang=js"
import style0 from "./SaveAsGoogleDriveSection.vue?vue&type=style&index=0&id=3d15cc9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d15cc9e",
  null
  
)

export default component.exports